import React from 'react'

import { classNames } from '@lib/simpleFn'

type SubmitModalProps = {
  afterSubmitCallback: () => void
  remainQuestionCount: number
  CloseModal: () => void
  timeout?: boolean
}

const SubmitModal: React.FC<SubmitModalProps> = ({
  afterSubmitCallback,
  remainQuestionCount,
  CloseModal,
  timeout,
}) => {
  let guideMessage
  if (remainQuestionCount) {
    guideMessage = (
      <div>
        <span>안 푼 문제가 ({remainQuestionCount}개) 남아 있습니다.</span>
        <br />
        <span>그래도 답안을 제출하시겠습니까?</span>
      </div>
    )
  } else {
    guideMessage = (
      <div>
        <span>답안을 제출하고 시험을 </span>
        <br className={'sm:hidden'} />
        <span>종료 하시겠습니까?</span>
      </div>
    )
  }

  if (timeout) {
    guideMessage = (
      <div>
        <span>시험이 시간이 종료되었습니다.</span>
      </div>
    )
  }
  return (
    <div className={'text-black pt-1'}>
      <h3 className={'font-bold text-2xl my-3'}>{timeout && '시험 종료 '}알림</h3>
      <h4 className={'font-bold text-lg my-3'}>{guideMessage}</h4>
      <div className={'flex flex-col sm:flex-row-reverse text-lg'}>
        <button
          className={classNames(
            ' w-[288px] bg-bosalpim text-white font-bold rounded-lg mx-auto py-4',
            timeout ? 'sm:w-[332px]' : 'sm:ml-2 sm:w-[162px]'
          )}
          onClick={() => afterSubmitCallback()}
        >
          답안 제출
        </button>
        {!timeout && (
          <button
            className={
              ' w-[288px] sm:w-[162px] border border-eaeaea mx-auto sm:mr-2 rounded-lg mt-4 sm:mt-0 py-4'
            }
            onClick={CloseModal}
          >
            취소
          </button>
        )}
      </div>
    </div>
  )
}

export default SubmitModal
